import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Gran Tour 360 | Tours Virtuais 360° Profissionais", 
  description = "Tours Virtuais 360° profissionais para Imobiliárias, Hotéis, Restaurantes, Salões de Festas, Escolas e Concessionárias. Onde cada detalhe convida a entrar.", 
  keywords = "tour virtual 360, tour 360 graus, visita virtual, tour virtual imobiliário, Gran Tour 360", 
  url = "https://grantour360.com.br",
  type = "website",
  image = "https://grantour360.com.br/images/og-image.jpg",
  schema 
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="pt_BR" />
      <meta property="og:site_name" content="Gran Tour 360" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Structured Data (Schema.org) */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
